import React, { useState } from 'react'

import { useMutation } from '@apollo/client'
import { Box, Button, TextField } from '@mui/material'

import Item from './Item'
import { ExtendTrialDocument } from '../../../../../__generated__/graphql'

interface TrialInfoProps {
  userId: string
  hasActiveTrial: boolean
  trialExpiresOn: string | null
  trialPlatform: string | null
  onTrialExtended: () => void
}

export default function TrialInfo({
  userId,
  hasActiveTrial,
  trialExpiresOn,
  trialPlatform,
  onTrialExtended,
}: TrialInfoProps) {
  const [extendTrialDays, setExtendTrialDays] = useState<string>('7')
  const [extendTrialMutation, { loading: extendTrialLoading }] =
    useMutation(ExtendTrialDocument)

  const handleExtendTrial = async () => {
    const days = parseInt(extendTrialDays, 10)
    if (Number.isNaN(days) || days <= 0) {
      return
    }

    await extendTrialMutation({
      variables: {
        userId,
        days,
      },
    })
    onTrialExtended()
  }

  const getTrialStatus = () => {
    if (hasActiveTrial) return 'Active'
    if (trialExpiresOn) return 'Expired'
    return 'None'
  }

  return (
    <>
      <Item label="Trial Status">{getTrialStatus()}</Item>
      {trialExpiresOn && (
        <>
          <Item label="Trial Expires On">
            {new Date(trialExpiresOn).toLocaleString()}
          </Item>
          <Item label="Trial Platform">{trialPlatform || 'Unknown'}</Item>
          <Item label="Extend Trial">
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <TextField
                label="Days"
                size="small"
                type="number"
                value={extendTrialDays}
                onChange={(e) => setExtendTrialDays(e.target.value)}
                sx={{ width: '100px' }}
              />
              <Button
                variant="contained"
                size="small"
                onClick={handleExtendTrial}
                disabled={extendTrialLoading}
              >
                Extend
              </Button>
            </Box>
          </Item>
        </>
      )}
    </>
  )
}
